import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser, setCompany, refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/login");
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data.user);
        // Pull fresh /auth/me to populate company
        const me = await api.get("/auth/me");
        setCompany(me.data.company || null);
        await refresh();
        window.history.replaceState({}, document.title, window.location.pathname);
        toast.success("Login realizado com sucesso!");
        navigate("/dashboard", { state: { user: data.user } });
      } catch (err) {
        toast.error("Falha no login Google");
        navigate("/login");
      }
    })();
  }, [navigate, setUser, setCompany, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-50">
      <div className="flex flex-col items-center gap-4">
        <img src="/logo.png" alt="Ultra" className="h-12 w-12 rounded-xl animate-pulse" />
        <div className="font-display text-xl font-bold">Autenticando...</div>
        <div className="font-body text-sm text-stone-500">Conectando sua conta Google</div>
      </div>
    </div>
  );
}
